import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const RadiusServerRoutes = defineRoute({
    record: {
        route: {
            path: "/radius-server",
            component: () => loadView(import("./RadiusServerTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/radius-server/:id",
            component: () => loadView(import("./RadiusServerDetail.vue")),
        },
        build(id: string) {
            return `/radius-server/${id}`;
        },
    },
});
